import React from 'react';

const SvgFuzzyCoin: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84.474 88.717"
      {...props}
    >
      <defs>
        <clipPath id="fuzzyCoin_svg__a">
          <path fill="none" d="M0 0h84.474v88.717H0z" />
        </clipPath>
        <style>{'.fuzzyCoin_svg__c{fill:#c72d7c;fill-rule:evenodd}'}</style>
      </defs>
      <g clipPath="url(#fuzzyCoin_svg__a)">
        <path
          className="fuzzyCoin_svg__c"
          d="M42.238 4.243A42.237 42.237 0 11.001 46.48 42.236 42.236 0 0142.238 4.243"
        />
        <path
          d="M42.238 0A42.237 42.237 0 11.001 42.238 42.237 42.237 0 0142.238 0"
          fill="#e573ca"
          fillRule="evenodd"
        />
        <path
          d="M75.501 18.402a40.877 40.877 0 012.663 4.231l-55.53 55.531a40.774 40.774 0 01-4.231-2.663zM63.213 7.097a41.146 41.146 0 0111.035 9.651l-57.5 57.5a41.133 41.133 0 01-9.651-11.035z"
          fill="#f9a2e8"
          fillRule="evenodd"
        />
        <path
          d="M42.238 8.959A33.278 33.278 0 118.959 42.238 33.279 33.279 0 0142.238 8.959"
          fill="#e583d2"
          fillRule="evenodd"
        />
        <path
          className="fuzzyCoin_svg__c"
          d="M42.238 8.959a33.279 33.279 0 0133.278 33.279c0 .367-.008.733-.02 1.1a33.276 33.276 0 00-66.517 0c-.011-.364-.02-.73-.02-1.1A33.279 33.279 0 0142.238 8.959"
        />
        <path
          d="M55.383 52.754c-.62.218-1.36.439-2.216.656q-1.366.342-2.738.631-1.451.3-2.984.465a28.267 28.267 0 01-3.012.164 31.977 31.977 0 01-5.365-.438 11.093 11.093 0 01-4.515-1.78 9.129 9.129 0 01-3.093-3.887 16.783 16.783 0 01-1.151-6.815V25.766a18.445 18.445 0 012.382-.379q1.133-.109 2.277-.114 1.04 0 2.243.114a16.757 16.757 0 012.355.382v15.216q0 3.285 1.1 4.489a4.3 4.3 0 003.339 1.2 13.977 13.977 0 001.423-.055 5.714 5.714 0 00.712-.114V25.766a18.459 18.459 0 012.376-.379q1.138-.109 2.276-.114 1.039 0 2.245.114a16.746 16.746 0 012.354.382zm.494 2.785c-5.463 13.144-24.094 8.405-24.094 8.405a7.42 7.42 0 011.347-9.061c9.881 5.419 19.055 1.312 21.841-.213z"
          fill="#c42f7c"
        />
        <path
          d="M53.888 51.469c-.62.219-1.36.439-2.216.657q-1.365.341-2.737.631-1.451.3-2.984.465a28.269 28.269 0 01-3.012.165 31.973 31.973 0 01-5.365-.438 11.091 11.091 0 01-4.515-1.78 9.126 9.126 0 01-3.092-3.887 16.781 16.781 0 01-1.151-6.815V24.481a18.49 18.49 0 012.382-.379q1.132-.108 2.276-.114 1.04 0 2.243.114a16.762 16.762 0 012.355.382V39.7q0 3.285 1.1 4.489a4.291 4.291 0 003.339 1.2 13.983 13.983 0 001.423-.055 5.773 5.773 0 00.711-.114V24.481a18.538 18.538 0 012.376-.379q1.138-.108 2.276-.114 1.038 0 2.245.114a16.8 16.8 0 012.353.382zm.494 2.785c-5.463 13.144-24.094 8.405-24.094 8.405a7.42 7.42 0 011.346-9.061c9.882 5.419 19.055 1.311 21.842-.213z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default SvgFuzzyCoin;
